import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "profile-picture-gallery-modal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header bg-secondary py-2 bg-gradient text-light" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6 col-sm-4 col-lg-2" }
const _hoisted_8 = { class: "profile-image rounded border border-1 ratio ratio-1x1 mb-4" }
const _hoisted_9 = { class: "profile-image rounded border border-1 mb-4" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "img-container" }
const _hoisted_13 = {
  class: "",
  style: {"height":"350px","max-height":"350px"},
  ref: "imageWorkArea"
}
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "d-flex justify-content-end" }
const _hoisted_17 = {
  key: 0,
  type: "button",
  class: "btn btn-outline-secondary mx-3 order-1",
  disabled: ""
}
const _hoisted_18 = {
  key: 1,
  class: "flex-grow-1"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-4 align-items-start mb-2" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "col-8 col-md-4 d-flex justify-content-end justify-content-md-center mb-2" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "col-12 col-md-4 d-flex justify-content-end mb-2" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "fas fa-spinner fa-spin fa-fw me-1"
}
const _hoisted_28 = {
  key: 1,
  class: "fas fa-save fa-fw me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "modal-title" }, [
            _createElementVNode("i", { class: "fas fa-camera fa-fw me-2" }),
            _createTextVNode(" Cambiar Foto de Perfil ")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-sm btn-close-white",
            "aria-label": "Close",
            ref: "close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 512)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectPictureFile())),
                    class: "btn"
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("i", {
                      class: "fa fa-upload d-block",
                      "aria-hidden": "true"
                    }, null, -1),
                    _createElementVNode("span", { class: "d-block" }, "Subir foto", -1)
                  ]))])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDefaultImages, (image) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: image.fullPath,
                  class: "col-6 col-sm-4 col-lg-2"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "btn p-0",
                      onClick: ($event: any) => (_ctx.saveProfilePicture(true, image.fullPath))
                    }, [
                      _createElementVNode("img", {
                        src: image.url,
                        alt: image.fullPath,
                        class: "rounded ratio ratio-1x1"
                      }, null, 8, _hoisted_11)
                    ], 8, _hoisted_10)
                  ])
                ]))
              }), 128))
            ])
          ], 512), [
            [_vShow, !_ctx.modeCrop]
          ]),
          _withDirectives(_createElementVNode("section", null, [
            _createElementVNode("input", {
              type: "file",
              class: "d-none",
              id: "uploaded-image",
              accept: "image/png,image/jpeg,image/jpg",
              ref: "uploadedImage",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadImage($event)))
            }, null, 544),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, null, 512)
            ])
          ], 512), [
            [_vShow, _ctx.modeCrop]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (!_ctx.modeCrop)
            ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.saving)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_17, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "fas fa-spinner fa-spin fa-fw me-1" }, null, -1),
                        _createTextVNode(" Actualizando ", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-outline-primary mx-3 order-1",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                      }, " Cerrar "))
                ])
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelCrop())),
                      disabled: _ctx.saving
                    }, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("i", { class: "far fa-arrow-alt-circle-left fa-fw me-1" }, null, -1),
                      _createTextVNode("Regresar ", -1)
                    ]))], 8, _hoisted_21)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectPictureFile())),
                      disabled: _ctx.saving
                    }, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("i", {
                        class: "fa fa-upload me-2",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode("Subir otro archivo ", -1)
                    ]))], 8, _hoisted_23)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-danger me-2",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal())),
                      disabled: _ctx.saving
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("i", { class: "fas fa-ban fa-fw me-1" }, null, -1),
                      _createTextVNode("Cancelar ", -1)
                    ]))], 8, _hoisted_25),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-success",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveProfilePicture(false))),
                      disabled: _ctx.saving
                    }, [
                      (_ctx.saving)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                        : (_openBlock(), _createElementBlock("i", _hoisted_28)),
                      _cache[14] || (_cache[14] = _createTextVNode("Aceptar ", -1))
                    ], 8, _hoisted_26)
                  ])
                ])
              ]))
        ])
      ])
    ])
  ]))
}